if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        // const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        // colorClassesToApply.forEach((colorClass) => {
        //   document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        // });

        const button = this.querySelector('button');

        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();
        this.onBodyClick = this.handleBodyClick.bind(this);

        // this.querySelector('button').addEventListener('click', () => {
        //   this.hide();
        // });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (target.closest('pickup-availability-drawer')) {
          this.hide();               
        }
      }

      hide() {
        this.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
 
        document.body.removeAttribute('data-lenis-prevent');
        document.body.removeEventListener('click', this.onBodyClick);
       
        
       // this.activeElement.focus();
        if(document.querySelector('quick-view-drawer').classList.contains('open')){
          setTimeout(() => {
            trapFocus(document.querySelector('quick-view-drawer'),this.activeElement);
          }, 1000); 
        }
        // removeTrapFocus(this.focusElement);
      }

      setActiveElement(element) {
        this.activeElement = element;
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setActiveElement(this.focusElement);
        setTimeout(() => {
          this.classList.add('open');
          document.body.classList.add('overflow-hidden');
        }, 200);


        document.body.setAttribute('data-lenis-prevent', 'true');
        this.backdropClose = this.querySelector('[data-backdrop-overlay]');
        this.data_close_drawer = this.querySelector('[data-drawer-close]');
        
        this.backdropClose.addEventListener('click', this.onBodyClick);
        this.data_close_drawer.addEventListener('click', this.onBodyClick);
        setTimeout(() => {
          const focusElment = document.querySelector('pickup-availability-drawer button');
          trapFocus(document.querySelector('pickup-availability-drawer'), focusElment);
        }, 1000);
        this.handleCursorMove();
      }
      handleCursorMove() {
        const cursorWrapper = this.querySelector('[data-cursor-hover]');

        gsap.set(cursorWrapper, { xPercent: 0, yPercent: 0 });

        const xTo = gsap.quickTo(cursorWrapper, 'x', { duration: 0.2, ease: 'power3' });
        const yTo = gsap.quickTo(cursorWrapper, 'y', { duration: 0.2, ease: 'power3' });

        this.backdropClose.addEventListener('mousemove', (e) => {
          gsap.to(cursorWrapper, { opacity: 1, scale: 1, duration: 0.1 });
          xTo(e.clientX);
          yTo(e.clientY);
        });
        this.backdropClose.addEventListener('mouseleave', (e) => {
          gsap.to(cursorWrapper, { scale: 0, duration: 0.1 });
        });
        this.backdropClose.addEventListener('mouseenter', (e) => {
          gsap.to(cursorWrapper, { scale: 1, duration: 0.1 });
        });
      }

      addEventListeners() {
        this.addEventListener('mouseenter', (e) => this.handleMouseEnter(e));
        this.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));
      }
    }
  );
}
